{
  "de": {
    "phase": {
      "attributes": {
        "end_date": "Enddatum",
        "internal_note": "Interne Notiz zur Phase",
        "name": "Name",
        "start_date": "Startdatum"
      },
      "labels": {
        "phase": "Keine Phase | Eine Phase | {count} Phasen"
      },
      "toasts": {
        "create": "Phase wurde erstellt",
        "delete": "Phase wurde gelöscht",
        "update": "Phase wurde aktualisiert"
      },
      "validation": {
        "needName": "Titel ist erforderlich",
        "needNumber": "Muss eine Zahl sein (z. B. 85)"
      }
    }
  }
}
